/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_Days_Fixed_LongInputs */

const en_us2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consecutive days need different muscles; we plan around your real week.`)
};

const pt_br2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias seguidos pedem músculos diferentes; planejamos em volta da sua semana real.`)
};

const es_419_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los días seguidos piden músculos distintos; planeamos en torno a tu semana real.`)
};

const pt_pt2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dias seguidos pedem músculos diferentes; planeamos à volta da tua semana real.`)
};

const fr_fr2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des jours consécutifs demandent des muscles différents ; on planifie selon ta vraie semaine.`)
};

const de_de2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufeinanderfolgende Tage brauchen unterschiedliche Muskeln; wir planen um deine echte Woche herum.`)
};

const it_it2_intake_why_days_fixed_long = /** @type {(inputs: Intake_Why_Days_Fixed_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giorni consecutivi richiedono muscoli diversi; pianifichiamo sulla tua settimana reale.`)
};

/**
* | output |
* | --- |
* | "Consecutive days need different muscles; we plan around your real week." |
*
* @param {Intake_Why_Days_Fixed_LongInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_days_fixed_long = /** @type {((inputs?: Intake_Why_Days_Fixed_LongInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_Days_Fixed_LongInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_days_fixed_long(inputs)
	if (locale === "es-419") return es_419_intake_why_days_fixed_long(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_days_fixed_long(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_days_fixed_long(inputs)
	if (locale === "de-DE") return de_de2_intake_why_days_fixed_long(inputs)
	if (locale === "it-IT") return it_it2_intake_why_days_fixed_long(inputs)
	return en_us2_intake_why_days_fixed_long(inputs)
});
export { intake_why_days_fixed_long as "intake.why.days_fixed.long" }